import type { RequirementRow } from "@/features/person/utils/pgm-requirements";
import { backgroundCheckFocusedPagePath } from "./backgroundCheckPaths";

export function withBackgroundCheckRequirementLinks(
  rows: RequirementRow[],
  options: { staffSectionVisible: boolean; canManageApplications: boolean; pgaId: string }
): RequirementRow[] {
  if (!options.staffSectionVisible || !options.canManageApplications) return rows;

  return rows.map((row) => {
    if (row.key !== "background_check" && row.name !== "Background Check") return row;

    return {
      ...row,
      detailPath: backgroundCheckFocusedPagePath(options.pgaId)
    };
  });
}
